import { reloadAll } from "../common/orm";
import { getCSRFToken } from '../common/Csrf'

export const AUTH_MFA_PENDING = "AUTH_MFA_PENDING";
export const AUTH_MFA_DISABLED = "AUTH_MFA_DISABLED";
export const AUTH_MFA_ENABLED = "AUTH_MFA_ENABLED";
export const AUTH_LOGIN_PENDING = "AUTH_LOGIN_PENDING";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_ERROR = "AUTH_LOGIN_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_PASSWORD_RESET_PENDING = "AUTH_PASSWORD_RESET_PENDING";
export const AUTH_PASSWORD_RESET_SUCCESS = "AUTH_PASSWORD_RESET_SUCCESS";
export const AUTH_PASSWORD_RESET_ERROR = "AUTH_PASSWORD_RESET_ERROR";
export const AUTH_PASSWORD_RECOVER_PENDING = "AUTH_PASSWORD_RECOVER_PENDING";
export const AUTH_PASSWORD_RECOVER_SUCCESS = "AUTH_PASSWORD_RECOVER_SUCCESS";
export const AUTH_PASSWORD_RECOVER_ERROR = "AUTH_PASSWORD_RECOVER_ERROR";
export const AUTH_PASSWORD_CHANGE_PENDING = "AUTH_PASSWORD_CHANGE_PENDING";
export const AUTH_PASSWORD_CHANGE_SUCCESS = "AUTH_PASSWORD_CHANGE_SUCCESS";
export const AUTH_PASSWORD_CHANGE_ERROR = "AUTH_PASSWORD_CHANGE_ERROR";

function isSuccess(response) {
    return response.status >= 200 && response.status < 300;
}

export function authLoginPending() {
    return {
        type: AUTH_LOGIN_PENDING
    };
}

export function authMfaPending(mfaTypes) {
    return {
        type: AUTH_MFA_PENDING,
        payload: {
            types: mfaTypes,
            isPending: true
        }
    };
}

export function authMfaEnabled() {
    return {
        type: AUTH_MFA_ENABLED
    };
}

export function authMfaDisabled() {
    return {
        type: AUTH_MFA_DISABLED
    };
}

export function authLoginSuccess(userInfo) {
    return {
        type: AUTH_LOGIN_SUCCESS,
        user: userInfo
    };
}

export function authLoginError(error) {
    return {
        type: AUTH_LOGIN_ERROR,
        error: error
    };
}

export function authLogin(values, history) {
    return function(dispatch) {
        dispatch(authLoginPending());
        return fetch("/_allauth/browser/v1/auth/login", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRFToken": getCSRFToken()
            },
            body: JSON.stringify({
                username: values.username,
                password: values.password
            })
        }).then(function(response) {
            if (isSuccess(response)) {
                return response.json().then(data => {
                    dispatch(authLoginSuccess(data.data.user));
                    dispatch(reloadAll());
                });
            } else {
                return response.json().then(data => {
                    if (response.status === 401 && data.data?.flows) {
                        const mfaFlow = data.data.flows.find(flow => flow.id === "mfa_authenticate");
                        if (mfaFlow) {
                            dispatch(authMfaPending(mfaFlow.types));

                            // Optionally: return a function that takes the TOTP code and submits it
                            return function submitMfa(code) {
                                return fetch("/_allauth/browser/v1/auth/2fa/authenticate", {
                                    method: "POST",
                                    headers: {
                                        Accept: "application/json",
                                        "Content-Type": "application/json",
                                        "X-CSRFToken": getCSRFToken()
                                    },
                                    credentials: "include",
                                    body: JSON.stringify({
                                        code: code,
                                        flow: "mfa_authenticate",
                                        type: "totp",
                                    })
                                }).then(async function(mfaResponse) {
                                    if (mfaResponse.ok) {
                                        const mfaData = await mfaResponse.json();
                                        dispatch(authLoginSuccess(mfaData.data.user));
                                        dispatch(reloadAll());
                                        return mfaData;
                                    } else {
                                        throw new Error("Invalid MFA code");
                                    }
                                });
                            };
                        } else {
                            // 401 with flows but no MFA step — account is inactive
                            dispatch(authLoginError("Your account is inactive. Please contact your account administrator."));
                        }
                    } else {
                        dispatch(authLoginError("Invalid Username/Password"));
                    }
                });
            }
        });
    };
}

// Unused
export function authLoginKeycloak(username) {
    return function(dispatch) {
        dispatch(authLoginPending());
        return fetch("/auth/keycloak/create", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                username: username
            })
        }).then(function(response) {
            if (isSuccess(response)) {
                return response.json().then(data => {
                    dispatch(authLoginSuccess(data));
                    dispatch(reloadAll());
                });
            } else {
                return dispatch(authLoginError("Invalid Username/Password"));
            }
        });
    };
}

// 8/13/25 TL;DR; bogus comment?
// FIXME: Bug found during impersonation setup
// If you are logged in and refresh the page this function will be called from the header
// There is no auth state set yet (there should be?) so it skips the token destroy but it does reload all the data
// reload all is also called from index (with the correct auth state)
// In some cases this reload all will return after the index reload all and the user data will be missing
export function authLogout(auth, history) {
    return async function(dispatch, getState) {
        // var { auth } = getState();
        await fetch("/_allauth/browser/v1/auth/session", {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRFToken": getCSRFToken()
            }
        });

        //clear cookies 
        document.cookie.split(";").forEach(cookie => {
            const name = cookie.split("=")[0].trim();
            if (name.startsWith("pageid")) {
                document.cookie = `${name}=; Max-Age=0; path=/`;
            }
        });

        const oauth_account = auth?.user?.oauth_account; 
        const city = auth?.user?.city_id;
        const oauth_url = auth?.user?.oauth_url;
        if (oauth_account) {  //this will send the url that we will link each account to. Update cauth/adapters to add new cities
            // window.location.href = window.location.origin + oauth_url; 
            history.push(oauth_url);
        }else{
            history.push("/");
        }
        // Don't need to wait for response
        dispatch({
            type: AUTH_LOGOUT
        });
        dispatch(reloadAll());
    };
}

export function authPasswordResetPending() {
    return {
        type: AUTH_PASSWORD_RESET_PENDING
    };
}

export function authPasswordResetSuccess(data) {
    return {
        type: AUTH_PASSWORD_RESET_SUCCESS,
        data: data
    };
}

export function authPasswordResetError(error) {
    return {
        type: AUTH_PASSWORD_RESET_ERROR,
        error: error
    };
}

// User requesting a password reset from the main page (step 1)
export function authPasswordReset(values) {
    return function(dispatch) {
        dispatch(authPasswordResetPending());
        return fetch("/_allauth/browser/v1/auth/password/request", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRFToken": getCSRFToken()
            },
            body: JSON.stringify({
                email: values.email
            })
        }).then(response => {
            if (isSuccess(response)) {
                dispatch(
                    authPasswordResetSuccess({
                        email: values.email
                    })
                );
            } else {
                dispatch(authPasswordResetError("Unknown Error. Please try again."));
            }
        });
    };
}

export function authPasswordRecoverPending() {
    return {
        type: AUTH_PASSWORD_RECOVER_PENDING
    };
}

export function authPasswordRecoverSuccess() {
    return {
        type: AUTH_PASSWORD_RECOVER_SUCCESS
    };
}

export function authPasswordRecoverError(error) {
    return {
        type: AUTH_PASSWORD_RECOVER_ERROR,
        error: error
    };
}

// User submitting a new password after receiving an email (step 2)
export function authPasswordRecover(values) {
    return function(dispatch) {
        dispatch(authPasswordRecoverPending());
        return fetch("/_allauth/browser/v1/auth/password/reset", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRFToken": getCSRFToken()
            },
            body: JSON.stringify(values)
        }).then(response => {
            if (isSuccess(response) || response.status === 401) { // Apparently 401 is good according to the demo...
                dispatch(authPasswordRecoverSuccess());
            } else if (response.status === 400) {
                return response.json().then(data => {
                    dispatch(authPasswordRecoverError(data));
                });
            } else {
                dispatch(authPasswordRecoverError({ error: "Unknown Server Error" }));
            }
        });
    };
}

export function authPasswordChangePending() {
    return { 
        type: AUTH_PASSWORD_CHANGE_PENDING
    };
}

export function authPasswordChangeSuccess() {
    return {
        type: AUTH_PASSWORD_CHANGE_SUCCESS
    };
}

export function authPasswordChangeError(error) {
    return {
        type: AUTH_PASSWORD_CHANGE_ERROR,
        error: error
    };
}

// User updating their own password from user edit page
export function authPasswordChange(values) {
    return function(dispatch, getState) {
        var { auth } = getState();

        if (auth && auth.user) {
            dispatch(authPasswordChangePending());
            return fetch("/_allauth/browser/v1/account/password/change", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-CSRFToken": getCSRFToken()
                },
                body: JSON.stringify(values)
            }).then(response => {
                if (isSuccess(response)) {
                    dispatch(authPasswordChangeSuccess());
                } else if (response.status === 400) {
                    return response.json().then(data => {
                        dispatch(authPasswordChangeError(data));
                    });
                } else {
                    dispatch(authPasswordChangeError({ error: "Unknown Server Error" }));
                }
            });
        }
    };
}
